import { Switch, FormControlLabel } from '@mui/material';
import { useUpdateRetailerMutation } from '../../api/api';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

type HideRetailerToggleProps = {
  retailerId: number;
  hidden: boolean;
};

export const HideRetailerToggle = (props: HideRetailerToggleProps) => {
  const { retailerId, hidden } = props;
  const [updateRetailer, { isLoading }] = useUpdateRetailerMutation();
  const { enqueueSnackbar } = useSnackbar();
  const [isToggled, setIsToggled] = useState(hidden);

  const handleToggle = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newHidden = event.target.checked;
    setIsToggled(newHidden);

    try {
      await updateRetailer({
        retailerId,
        hidden: newHidden,
      }).unwrap();

      enqueueSnackbar(
        `Retailer successfully ${newHidden ? 'hidden' : 'displayed'}`,
        { variant: 'success' }
      );
    } catch {
      setIsToggled(hidden);
      enqueueSnackbar('Failed to update retailer visibility', {
        variant: 'error',
      });
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={isToggled}
          onChange={e => void handleToggle(e)}
          disabled={isLoading}
          size="small"
        />
      }
      label=""
      sx={{ margin: 0 }}
    />
  );
};
